import { WifiInfo } from "@core/ability";

export interface ICustomeDevcie {
  key: string;
  name: string;
  code: string;
  type: "computer" | "ifpd";
  extra?: WifiInfo;
}

export const createDeviceByCode: (pinCode: string) => ICustomeDevcie = (pinCode: string) => {
  return {
    key: "",
    name: "",
    code: "",
    type: "ifpd",
    extra: {
      bssid: '',
      deviceName: '',
      deviceType: -1,
      interval: -1,
      ip: '',
      localIp: '',
      passwd: '',
      pinCode: pinCode,
      port: -1,
      rssi: -1,
      ssid: '',
    }
  };
}

export interface IQrCodeAuthParams {
  qrCodeId: string;
}

export interface IQrCodeAuthRes {
  bindCount: number;
  maxBindCount: number;
}
